import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as dateNumActions from '@/store/actions/dateNum';
import { Popover, Button, Popconfirm, Icon, Select, Checkbox, Input, Breadcrumb, Modal, message, TimePicker } from 'antd'
import './index.less'
import { LimitTextArea } from 'antd-input'
import { Scrollbars } from 'react-custom-scrollbars';
import { reqByGet } from '@/api/api'
import servers from '@/api/server'
import DatePicker from './datePickerHour'
import moment from 'moment';
import { arrayOf } from 'prop-types';
import { is } from 'immutable';
// import create from 'antd/lib/icon/IconFont';

const { Option } = Select;
class weekTocreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentDay: '',
            currentMonth: '',
            currentYear: '',
            selectList: [],
            selectValue: 1,
            isSelect: true,
            currentList: [],
            // numberList: Array(24).fill(0),
            numberList: [],
            weekList: [
                { name: '一', className: '' },
                { name: '二', className: '' },
                { name: '三', className: '' },
                { name: '四', className: '' },
                { name: '五', className: '' },
                { name: '六', className: '' },
                { name: '日', className: '' }
            ],
            dayList: [],
            allTimeList: Array(24 * 7).fill({ dataTime: [] }),
        }
        this.changeWeek = this.changeWeek.bind(this)
        this.initCalendar = this.initCalendar.bind(this);
        this.renderHeader = this.renderHeader.bind(this);
        this.renderBody = this.renderBody.bind(this);
        this.preMonth = this.preMonth.bind(this);
        this.nextMonth = this.nextMonth.bind(this);
    }
    componentWillMount() {
        reqByGet(servers.backlogTagGetTagName, {}, res => {
            console.log(res)
            this.setState({
                selectList: res.rows
            })
        }, err => {
            console.log(err)
        })
    }
    componentDidMount() {
        this.datalist()
        let list = []
        for (let i = 6; i < 24; i++) {
            list.push((i))
        }
        let mylist = [0, 1, 2, 3, 4, 5]
        console.log(list)
        this.setState({
            numberList: list.concat(mylist)
        })
    }
    datalist = () => {
        this.initCalendar()
    }
    refer = () => {
        reqByGet(servers.backlogTagGetTagName, {}, res => {
            console.log(res)
            this.setState({
                selectList: res.rows
            })
        }, err => {
            console.log(err)
        })
    }
    // 获取当前date的当月第一天的字符串形式
    getMonthFirstDate(date) {
        let nowYear = date.getFullYear(); // 获取年份
        let nowMonth = date.getMonth() + 1; // 获取月份
        return `${nowYear}-${nowMonth}-01`
    }
    getTodalDate(date) {
        let nowYear = date.getFullYear(); // 获取年份
        let nowMonth = this.formatNumber(date.getMonth() + 1); // 获取月份
        let nowDate = this.formatNumber(date.getDate());
        return `${nowYear}-${nowMonth}-${nowDate}`
    }
    getMonthDate = (date) => {
        let nowYear = date.getFullYear(); // 获取年份
        let nowMonth = this.formatNumber(date.getMonth() + 1); // 获取月份
        return `${nowYear}-${nowMonth}`
    }

    // 获取当前date的字符串形式
    getDateString(date) {
        let nowYear = date.getFullYear(); // 获取年份
        let nowMonth = this.formatNumber(date.getMonth() + 1); // 获取月份
        let day = date.getDate();
        day = day < 10 ? '0' + day : day;
        return `${nowYear}-${nowMonth}-${day}`
    }

    // 上个月
    preMonth() {
        if (!this.state.isSelect) {
            // currentIndex--
            this.changeWeek(-1)
        } else {
            let date = new Date(`${this.state.currentYear}-${this.state.currentMonth}-${this.state.currentDay}`)
            let preMonthFirstDate = new Date(this.getMonthFirstDate(new Date(date.setDate(0)))); // 0 是上个月最后一天
            console.log(preMonthFirstDate.getMonth())
            this.initCalendar(preMonthFirstDate)
        }

    }
    //动态设置上一周下一周
    changeWeek(weekNum) {
        console.log(this.state.currentList[0].cTMD)//拿到周一
        let date = new Date(this.state.currentList[6].cTMD)
        let befortDate = new Date(new Date(this.state.currentList[0].cTMD).getTime() - (24 * 60 * 60 * 1000))//前一天
        let currentDay = date.getDay()
        console.log(currentDay)
        this.create(-currentDay + (7 * weekNum), befortDate)
    }
    // 下个月
    nextMonth() {
        if (!this.state.isSelect) {
            // currentIndex++
            this.changeWeek(1)
        } else {
            let date = new Date(`${this.state.currentYear}-${this.state.currentMonth}-${this.state.currentDay}`)
            let nextMonthFirstDate = new Date(this.getMonthFirstDate(new Date(date.setDate(33))));//下个月的一号
            console.log(nextMonthFirstDate.getMonth())//
            this.initCalendar(nextMonthFirstDate)
        }

    }
    create = (weekNum, nowDate) => {
        let currentList = [];
        for (let i = weekNum + 1; i <= weekNum + 7; i++) {
            currentList.push(this.countTime(i, nowDate))
        }
        this.setState({
            currentList,
            currentYear: currentList[6].getYear,
            currentMonth: currentList[6].getMonth
        }, () => {
            if (!this.state.isSelect) {
                this.weekSelectList()
            }

        })

        console.log(currentList)
    }
    countTime = (n, nowDate) => {
        let data = nowDate ? nowDate : new Date()
        let getTime = data.getTime() + (24 * 60 * 60 * 1000) * n;
        let needTime = new Date(getTime);//获取时间格式
        let getYear = needTime.getFullYear();
        let getMonth = this.formatNumber(needTime.getMonth() + 1);//获取月
        let getDat = this.formatNumber(needTime.getDate());//获取日
        let obj = {
            getYear,
            getMonth,
            getDat,
            cTMD: `${getYear}-${getMonth}-${getDat}`
        }
        return obj
    }
    formatNumber = (num) => {
        return num < 10 ? '0' + num : num
    }
    weekSelectList = () => {
        const { currentList, allTimeList } = this.state
        reqByGet(servers.backlogListDataList, { queryTWeek: 1, startDate: currentList[0].cTMD, endDate: currentList[6].cTMD }, res => {
            console.log(res)
            let numList = []
            try {
                currentList.map((el, index) => {
                    res.rows.map(x => {
                        if (el.cTMD === x.endDate) {
                            let obj = {}
                            obj.data = x
                            obj.index = index
                            obj.hours = x.endDateTime.substring(11, 13) === '00' ? 24 : x.endDateTime.substring(11, 13)
                            numList.push(obj)
                        }
                    })
                })
            } catch (e) {
                console.log(e)
            }
            let mylist = Array(24 * 7).fill()
            console.log(numList)
            numList.map(el => {
                let allIndex
                if (el.hours - 6 > 0) {
                    allIndex = (el.hours - 0 - 6) * 7 + el.index
                } else {
                    allIndex = (el.hours - 0 + 18) * 7 + el.index
                }
                console.log(allIndex)
                // console.log(mylist[allIndex])
                if (mylist[allIndex]) {
                    mylist[allIndex].dataTime.push(el.data)
                } else {
                    let obj = {}
                    obj.dataTime = []
                    obj.dataTime.push(el.data)
                    mylist[allIndex] = obj
                }

            })
            this.setState({
                allTimeList: mylist
            })
        }, err => {

        })
    }
    // 初始化日历
    initCalendar(currentDate) {
        const that = this
        let nowDate = currentDate ? currentDate : new Date();
        console.log(nowDate.getDay())
        let nowMonthFirstDate = this.getMonthFirstDate(nowDate) // 获取当月1号日期
        let myMonthDate = this.getMonthDate(nowDate)//获取当前年+月
        console.log(myMonthDate)
        let weekDay = nowDate.getDay() ? nowDate.getDay() : 7 //获取今天是周几
        that.create(-weekDay, nowDate)
        reqByGet(servers.backlogListDataList, { queryTMonth: myMonthDate }, res => {
            let allReport = []
            console.log(res)
            allReport = res.rows
            let nowWeek = new Date(nowMonthFirstDate).getDay() ? new Date(nowMonthFirstDate).getDay() : 7; // 获取星期
            let newDateList = []; // 创建日期数组
            let startDay = 2 - nowWeek; // 开始日期的下标  以为 setDate(0)是上个月最后一天  所以是2-nowWeek

            let showDayLength = nowWeek < 6 ? 35 : 42;  // 如果5行能显示下一个月 就只显示5行
            // 循环处理 获取日历上应该显示的日期
            for (let i = startDay; i < startDay + showDayLength; i++) {
                let date = new Date(new Date(nowMonthFirstDate).setDate(i)); // 获取时间对象
                let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() // 小于9的数字前面加0
                let dataTime = that.getDateString(date)
                let dateList = []
                allReport.map(el => {
                    if (el.endDate === dataTime) {
                        dateList.push(el)
                    }
                })
                let dayObject = {
                    date: dataTime,
                    day,
                    dateList,
                    className: '',
                }
                // new Date(str).toDateString() === new Date().toDateString()
                if (date.toDateString() === new Date().toDateString()) {
                    dayObject.className = 'today'
                }
                newDateList.push(dayObject)
            }
            console.log(newDateList)
            that.setState((pre) => {
                return {
                    dayList: newDateList,
                    currentDay: nowDate.getDate(),
                    currentMonth: nowDate.getMonth() + 1 >= 10 ? nowDate.getMonth() + 1 : '0' + (nowDate.getMonth() + 1),
                    currentYear: nowDate.getFullYear(),
                }
            })
        }, err => {
            console.log(err)
        })//查询事件
    }
    onchangeCheck = (x, flag) => {
        let status = 1
        if (flag) {
            status = 2
        }
        reqByGet(servers.backlogListSave, { id: x.id, status }, res => {
            if (res.statusCode !== 1000) {
                Modal.error({
                    content: res.message
                })
                return
            }
            this.props.updateDateNum()
            message.success("修改成功")
            this.initCalendar(new Date(x.endDateTimeString))
        }, err => {
            console.log(err)
        })
    }
    renderHeader() {
        const { currentYear, currentMonth, currentList } = this.state
        const that = this
        let weekDate
        console.log(currentList)
        if (!currentList.length) {
            return
        }
        if (!this.state.isSelect) {
            weekDate = currentYear + '年' + currentList[0].getMonth + '月' + currentList[0].getDat + '日' + '-' + currentList[6].getMonth + '月' + currentList[6].getDat + '日'
        } else {
            weekDate = currentYear + '年' + currentMonth + '月'
        }
        return (
            <div className='calendar-header'>
                <div className='calendar-header-left' style={{ flex: "0.32", paddingLeft: '0' }}>
                </div>
                <div className='tc' style={{ flex: "0.4" }}>
                    <Icon type="caret-left" onClick={this.preMonth} />
                    {weekDate}
                    <Icon type="caret-right" className='ml5' onClick={this.nextMonth} />
                </div>
                <div className='calendar-header-right' style={{ flex: "0.26" }}>
                    <div>
                        <span className='selectDate' style={{ marginLeft: "0" }}>
                            <span className={`yselect ${this.state.isSelect && 'selectHover'}`} onClick={() => {
                                let data = new Date(`${this.state.currentYear}-${this.state.currentMonth}-1`)
                                this.setState({
                                    isSelect: true
                                })
                                this.initCalendar(data)
                            }}>月</span>
                            <span className={`wselect ${!this.state.isSelect && 'selectHover'}`} onClick={() => {
                                this.setState({
                                    isSelect: false
                                })
                                this.weekSelectList()
                            }}>周</span>
                        </span>
                    </div>
                </div>
            </div >
        )
    }
    chekedDelect = (x) => {
        reqByGet(servers.backlogListDelete, { id: x.id }, res => {
            if (res.statusCode !== 1000) {
                Modal.error({
                    content: res.message
                })
                return
            }
            message.success("删除成功")
            if (this.state.isSelect) {
                this.initCalendar(new Date(x.endDateTimeString))
            } else {
                this.weekSelectList()
            }

        }, err => {
            console.log(err)
        })
    }
    mapInDiv = (x, cls, selectV, type, time) => {
        const that = this
        return (
            <div className='mapDiv1' onClick={(e) => e.stopPropagation()}>
                <span className={`f12 mb5 ${cls}`} style={{ display: "block" }}>
                    {selectV}
                </span>
                <div className='mb5'>
                    <Checkbox
                        // checked={false}
                        checked={x.status == 2 ? true : false}
                        onChange={(e) => {
                            this.onchangeCheck(x, e.target.checked)
                        }}
                    >
                        <span style={{ lineHeight: "1.5" }} className={x.status == 2 ? 'tdLT' : ''}>{x.content}</span>
                    </Checkbox>
                </div>
                <div className='clear' style={{ color: "#000" }}>
                    <span className={`fl f12`}><i className='iconfont icon-shijian f14'></i> {type ? x.endDateTimeString : x.endDateTimeString}</span>
                </div>
            </div >
        )
    }
    setValue = (file, value) => {
        this.setState({
            [file]: value
        })
        console.log(file, value)
    }
    onChange = (time) => {
        this.setState({
            TimePicker: time
        })
    }
    mapDiv = (res, flag, isWeek) => {
        console.log(flag, isWeek)
        return (
            <div className='mapDiv1'>
                <Select
                    value={this.state.input}
                    placeholder={'请选择'}
                    style={{ width: 110 }}
                    size='small'
                    onChange={(value) => {
                        console.log(value)
                        this.setValue('input', value)
                    }}
                    bordered={false}
                >
                    {this.state.selectList.map(el => {
                        return (
                            <Option value={el.id} key={el.id}><span className='f12'>{el.name}</span></Option>
                        )

                    })}
                </Select>
                {/* <Input
                    className='inputMylist'
                    placeholder='标签名'
                    value={this.state.input}
                    size='small'
                    onChange={(e) => this.setState({ input: e.target.value })}
                    maxLength={10}
                    suffix={<i className='iconfont icon-bianji2'></i>}
                /> */}
                <div className='mt10'>
                    <Select
                        value={this.state.selectValue}
                        style={{ width: 80 }}
                        size='small'
                        onChange={(value) => {
                            console.log(value)
                            this.setValue('selectValue', value)
                        }}
                        bordered={false}
                    >
                        <Option value={1}><span className='c_red2 f12'>High</span></Option>
                        <Option value={2}><span className='c_green4 f12'>Middle</span></Option>
                        <Option value={3}><span className='c_8bff f12'>Low</span></Option>
                        <Option value={4}><span className='c_8e f12'>Nice To Have</span></Option>
                    </Select>
                </div>
                <div className='mt10'>
                    <LimitTextArea
                        rows={2}
                        value={this.state.limitText}
                        onChange={(e) => this.setState({ limitText: e.target.value })}
                        maxLength={50}
                        placeholder={'请输入内容'}
                    />
                </div>
                {isWeek && <span className='f12 mt5'><i className='iconfont icon-shijian f14'></i> {res.date}</span>}
                {!flag && !isWeek &&
                    <div className='mt10'>
                        <TimePicker value={this.state.TimePicker} placeholder='请设置结束时间' size="small" onChange={this.onChange} />
                    </div>
                }
                {flag && <DatePicker
                    type={0}
                    feild='date'
                    width={157}
                    className='Datepicker_1 f12 mt5'
                    setValue={this.setValue}
                    format="YYYY-MM-DD HH:mm:ss"
                    showTimeFlag={false}
                />}
                <div className='tc mt10'>
                    <span className='newrePort downloadColor2  mr5' onClick={() => {
                        this.setValue('visible' + res.date, false)
                        this.setValue('visible', false)
                    }}>取消</span>
                    <span className='newrePort' onClick={() => this.primary(res, flag, isWeek)}>保存</span>
                </div>
            </div>
        )
    }
    primary = (params, flag, isWeek) => {
        let timePicker = this.state.TimePicker && this.state.TimePicker.format('HH:mm:ss')
        if (!flag && !isWeek && !timePicker) {
            message.error("请选择结束时间")
            return
        }
        if (!this.state.limitText) {
            message.error("请输入内容!")
            return
        }
        let nowTime = params.date + ' ' + timePicker
        let newTime = this.state.date && this.state.date.format('YYYY-MM-DD HH:mm:ss')
        let obj = {
            level: this.state.selectValue,
            content: this.state.limitText,
            endDateTimeString: flag ? newTime : isWeek ? params.date : nowTime,
            tagId: this.state.input
        }
        if (this.state.divType === 'last') {
            obj.id = this.state.divTypeId
        }
        console.log(obj)
        reqByGet(servers.backlogListSave, { ...obj }, res => {
            console.log(res)
            if (res.statusCode !== 1000) {
                Modal.error({
                    content: res.message
                })
                return
            }
            message.success('新增成功')
            if (isWeek) {
                this.weekSelectList()
            } else {
                this.initCalendar(flag ? new Date(newTime) : new Date(nowTime))
            }

            this.setValue('visible' + params.date, false)
            // this.setValue('visible', false)
        })
    }
    renderBody() {
        const that = this
        const { currentList, selectList } = this.state
        if (this.state.isSelect) {
            return (
                <div className='calendar-body'>
                    <div className='week-container'>
                        {this.state.weekList.map(week => {
                            return <div key={week.name} className={`week ${week.className}`}>{week.name}</div>
                        })}
                    </div>
                    <div className='day-container'>
                        {this.state.dayList.map((dayObject, index) => {
                            return (
                                <div key={index} className={`day ${dayObject.className}`} style={{ height: "78px", padding: '2px' }}>
                                    <span className='waiSpan pr' onClick={() => {
                                        this.setState({
                                            limitText: "",
                                            input: this.state.selectList[0].id,
                                            TimePicker: '',
                                            divType: "new",
                                            selectValue: 1
                                        })
                                        console.log(dayObject.date)
                                    }}>
                                        <span className='number'>{dayObject.day}</span>
                                        <Scrollbars className='myScroll' style={{ height: '50px' }}>
                                            {dayObject.dateList.map(x => {
                                                let cls = ''
                                                let selectV = ''

                                                switch (x.level) {
                                                    case 1:
                                                        selectV = 'High'
                                                        cls = 'c_red2'
                                                        break;
                                                    case 2:
                                                        selectV = 'Middle'
                                                        cls = 'c_green4'
                                                        break;
                                                    case 3:
                                                        selectV = 'Low'
                                                        cls = 'c_8bff'
                                                        break;
                                                    default:
                                                        selectV = 'Nice To Have'
                                                        cls = 'c_8e'
                                                }
                                                return (
                                                    <span className='toshenglu' style={{ paddingRight: '6px' }} onClick={(e) => e.stopPropagation()} key={x.id}>
                                                        <i className={`iconfont icon-dian ${cls}`}></i>
                                                        <Popover
                                                            placement="bottom"
                                                            // onVisibleChange={(flag) => this.setValue('visible' + dayObject.date, flag)}
                                                            // visible={this.state['visible' + dayObject.date]}
                                                            content={that.mapInDiv(x, cls, selectV)}
                                                            trigger="hover">
                                                            <span className={x.status == 2 ? 'tdLT c_66' : 'c_66'}>{x.content}</span>
                                                        </Popover>
                                                    </span>

                                                )
                                            })}
                                        </Scrollbars>
                                    </span>
                                </div>)
                        })}
                    </div>
                </div >
            )
        } else {
            return (
                <Scrollbars className='myScroll' style={{ height: '440px' }} autoHide>
                    <div className='my_body' style={{ paddingRight: "10px" }}>
                        <ul style={{ marginTop: "39px" }}>
                            {this.state.numberList.map((el, index) => {
                                return <li key={index} style={{ height: "75px", lineHeight: "75px" }}>{el}:00</li>
                            })}
                        </ul>
                        <div className='calendar-body'>
                            <div className='week-container1'>
                                {this.state.weekList.map((week, index) => {
                                    return (
                                        <div key={week.name} className={`week pr ${week.className}`}>
                                            {week.name}
                                            <span className='weekspan' style={{ right: "2px", button: '-1px' }}>
                                                {currentList[index].getMonth}/{currentList[index].getDat}
                                            </span>
                                        </div>
                                    )
                                })}
                            </div>
                            <div className='day-container1'>
                                {this.state.allTimeList.map((el, index) => {
                                    let time = currentList[index % 7].cTMD + ' ' + that.formatNumber(parseInt(index / 7) + 1) + ':00:00'
                                    let isToday = currentList[index % 7].cTMD === this.getTodalDate(new Date())
                                    return (
                                        <div key={index} className={`day`} style={{ backgroundColor: isToday ? '#F7FFF6' : "", height: "75px", padding: "2px" }} >
                                            <span className='waiSpan pr' onClick={() => {
                                                this.setState({
                                                    limitText: "",
                                                    input: this.state.selectList[0].id,
                                                    TimePicker: '',
                                                    divType: "new",
                                                    selectValue: 1
                                                })
                                            }}>
                                                <Scrollbars className='myScroll' style={{ height: '50px' }}>
                                                    {el && el.dataTime.map(x => {
                                                        let cls = ''
                                                        let selectV = ''
                                                        switch (x.level) {
                                                            case 1:
                                                                selectV = 'High'
                                                                cls = 'c_red2'
                                                                break;
                                                            case 2:
                                                                selectV = 'Middle'
                                                                cls = 'c_green4'
                                                                break;
                                                            case 3:
                                                                selectV = 'Low'
                                                                cls = 'c_8bff'
                                                                break;
                                                            default:
                                                                selectV = 'Nice To Have'
                                                                cls = 'c_8e'
                                                        }
                                                        return (
                                                            <span className='toshenglu' onClick={(e) => e.stopPropagation()} key={x.id}>
                                                                <i className={`iconfont icon-dian ${cls}`}></i>
                                                                <Popover
                                                                    placement="bottom"
                                                                    // onVisibleChange={(flag) => this.setValue('visible' + dayObject.date, flag)}
                                                                    // visible={this.state['visible' + dayObject.date]}
                                                                    content={that.mapInDiv(x, cls, selectV, 1, time)}
                                                                    trigger="hover">
                                                                    <span className={x.status == 2 ? 'tdLT c_66' : 'c_66'}>{x.content}</span>
                                                                </Popover>
                                                            </span>

                                                        )
                                                    })}
                                                </Scrollbars>
                                            </span>

                                        </div>)
                                })}
                            </div>
                        </div>

                    </div>
                </Scrollbars>
            )
        }


    }

    render() {
        return (
            <div className='body_Con'>
                <div className='calendar' style={{ marginTop: "0" }}>
                    {this.renderHeader()}
                    {this.renderBody()}
                </div>
            </div>
        )
    }
}
// export default weekTocreate


function mapStateToProps(state) {
    return {
        dateNum: state.dateNum,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ ...dateNumActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(weekTocreate);
